import { FC } from "react";
import CustomButton from "../../UI/Buttons/CustomButton";
import { PaginationLink } from "../../../store/superadmin/types";
import DefaultCentreImg from "../../../assets/img/Buildings.svg";
import PaginationControls from "../../Pagination/PaginationControls";
import { DEFAULT_ITEMS_PER_PAGE } from "../../../constants/app";
import { IPaginatedData, TCentreCandidatesJobs } from "../../../store/candidate/types";

interface ListItemsProps {
  allDetailsLists: IPaginatedData<TCentreCandidatesJobs> | null;
  handleCentreViewModal: (id: number) => Promise<void>;
  currentPage: number;
  totalPages: number;
  paginationLinks: PaginationLink[];
  onPageChange: (url: string | null) => void;
  setPerPageList: (value: number) => void;
  setCurrentPage: (value: number) => void;
  isStage3Activate?: boolean;
  documentsExpired?: boolean;
}

const ListItems: FC<ListItemsProps> = ({
  allDetailsLists,
  handleCentreViewModal,
  currentPage,
  totalPages,
  paginationLinks,
  onPageChange,
  setPerPageList,
  setCurrentPage,
  isStage3Activate,
  documentsExpired
}) => {
  return (
    <>
      {allDetailsLists && allDetailsLists?.total > 0 ? (
        allDetailsLists.data.map(
          (
            candidateJobDataOverCentre: TCentreCandidatesJobs,
            index: number
          ) => (
            <div
              key={index}
              className="border-bottom border-off-white d-flex flex-column flex-lg-row gap-20 gap-mobile-10 align-items-center px-15px py-10px  fs-13 fw-400 text-black"
            >
              <div className={`w-50px h-50px radius-50px bg-white d-flex align-items-center justify-content-center ${candidateJobDataOverCentre?.photo === null ? `border-solid border-2 border-dark radius-40px` : ``}`}>
                <img
                  src={candidateJobDataOverCentre.photo || DefaultCentreImg}
                  width={`${
                    candidateJobDataOverCentre?.photo !== null
                      ? "50"
                      : "24"
                  }`}
                  height={`${
                    candidateJobDataOverCentre?.photo !== null
                      ? "50"
                      : "24"
                  }`}
                  // width={50}
                  // height={50}
                  alt="Centre"
                  className="img-responsive rounded-circle object-fit-cover"
                />
              </div>
              <div className="min-w-240px flex-grow-1 text-break">
                <div className="d-flex flex-column gap-3">
                  <div className="fs-16 fw-700 text-black">
                    {candidateJobDataOverCentre.business_name}
                  </div>
                  <div className="fs-13 fw-400 text-black">
                    {candidateJobDataOverCentre.address}
                  </div>
                </div>
              </div>
              <div className="min-w-135px w-135px text-break">
                {candidateJobDataOverCentre.current_jobs_count} {candidateJobDataOverCentre.current_jobs_count !== 1 ? "Jobs" : "Job"} { candidateJobDataOverCentre.urgent_jobs_count > 0 ? `Total` : ""} <span className="text-alert">{ candidateJobDataOverCentre.urgent_jobs_count > 0 ? `(${candidateJobDataOverCentre.urgent_jobs_count} Urgent)` : ""}</span>
              </div>
              <div className="min-w-120px w-120px text-break">{candidateJobDataOverCentre.past_jobs_count} {candidateJobDataOverCentre.past_jobs_count !== 1 ? "Jobs" : "Job"}</div>
              <div className="min-w-115px w-115px text-break">{candidateJobDataOverCentre.last_job_date ?? "–"}</div>
              <div className="min-w-130px w-130px text-break">
                <CustomButton
                  variant={"primary"}
                  type="button"
                  className="btn-theme bg-teal text-black"
                  onClick={() => handleCentreViewModal(candidateJobDataOverCentre.id)}
                  disabled={(isStage3Activate && !documentsExpired) ? false : true}
                >
                  View Profile
                </CustomButton>
              </div>
            </div>
          )
        )
      ) : (
        <div className="d-flex gap-20 align-items-center justify-content-center text-center p-15px">
          <div className="fs-16 fw-400 text-grey-medium">No Centres found</div>
        </div>
      )}
      {allDetailsLists &&
        allDetailsLists?.total > DEFAULT_ITEMS_PER_PAGE && (
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            paginationLinks={paginationLinks}
            onPageChange={onPageChange}
            setPerPageList={setPerPageList}
            setCurrentPage={setCurrentPage}
          />
        )}
    </>
  );
};

export default ListItems;
